import { iIconProps } from '../icon';

export default function ArrowRightIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 40 40' {...props}>
            <path d='M21.886 5.886a4.438 4.438 0 00-6.28 0l11.895 11.895H4a4.571 4.571 0 004.438 4.438h19.063L15.606 34.114a4.438 4.438 0 006.28 0L36 20 21.886 5.886z' />
        </svg>
    );
}
